<template>
  <div class="tab-bar router-partial-active bg-white border-t border-50">
    <ul class="flex h-block">
      <router-link tag="li" class="flex-1 text-center text-xs" :to="{name: 'todos'}" style="padding-top: 6px;">
        <svg
          class="mx-auto mb-1"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          width="24"
          height="24"
        >
          <path
            fill="currentColor"
            d="M12 22a10 10 0 1 1 0-20 10 10 0 0 1 0 20zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm1-8.41l2.54 2.53a1 1 0 0 1-1.42 1.42L11.3 12.7A1 1 0 0 1 11 12V8a1 1 0 0 1 2 0v3.59z"
          />
        </svg>
        {{ $t("My Todos") }}
      </router-link>

      <router-link v-if="shouldDisplayChecks" tag="li" class="flex-1 text-center text-xs" :to="{name: 'checklists'}" style="padding-top: 6px;">
        <svg
          class="mx-auto mb-1"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          width="24"
          height="24"
        >
          <path
            fill="currentColor"
            d="M9 15.59l10.3-10.3a1 1 0 0 1 1.4 1.42l-11 11a1 1 0 0 1-1.4 0l-5-5a1 1 0 0 1 1.4-1.42l4.3 4.3z"
          />
        </svg>
        {{ $t("Inspections") }}
      </router-link>

      <router-link v-if="shouldDisplayIssues" tag="li" class="flex-1 text-center text-xs" :to="{name: 'issues'}" style="padding-top: 6px;">
        <BellIcon class="mx-auto mb-1" />
        {{ $t("Issues") }}
      </router-link>

      <router-link v-if="shouldDisplayRaiseIssues" tag="li" class="flex-1 text-center text-xs" :to="{name: 'issues-raise'}" style="padding-top: 6px;">
        <BellIcon class="mx-auto mb-1" />
        {{ $t("Raise issue") }}
      </router-link>

      <li class="flex-1">
        <dropdown class>
          <dropdown-trigger slot-scope="{toggle}" class="text-center text-xs h-block" :handle-click="toggle" :show-arrow="false" style="display: block; padding-top: 6px;">
            <div style="position: relative; width: 24px;" class="mx-auto">
              <span
                v-if="unreadCount"
                class="bg-red border-0 rounded-full text-white px-1 absolute font-semibold text-xs"
                style="top: -0.2rem; right: -1.2rem; height: 1rem; line-height: 1rem; min-width: 1rem; text-align: center;"
              >{{ unreadCount }}</span>
              <svg
                class="mx-auto mb-1"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                width="24"
                height="24"
              >
                <path
                  fill="currentColor"
                  d="M4 15a3 3 0 1 1 0-6 3 3 0 0 1 0 6zm0-2a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm8 2a3 3 0 1 1 0-6 3 3 0 0 1 0 6zm0-2a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm8 2a3 3 0 1 1 0-6 3 3 0 0 1 0 6zm0-2a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"
                />
              </svg>
            </div>
            {{ $t("More") }}
          </dropdown-trigger>

          <dropdown-menu slot="menu" class width="200" direction="rtl">
            <div v-cloak v-if="user" class="p-3">
              <span class="text-90">{{ user.name }}</span>

              <template v-if="user.organization">
                <br />
                <small>{{ user.organization }}</small>
              </template>
            </div>
            <ul>
              <li>
                <router-link
                  :to="{name: 'profile'}"
                  class="block no-underline text-90 hover:bg-30 p-3"
                >{{$t("Profile")}}</router-link>
              </li>
              <li>
                <router-link
                  :to="{name: 'notifications'}"
                  class="block no-underline text-90 hover:bg-30 p-3 relative pr-8"
                >
                  {{$t("Notifications")}}
                  <span
                    v-if="unreadCount"
                    class="bg-red border-0 rounded-full text-white px-1 absolute font-semibold text-xs"
                    style="top: 50%; right: 0.5rem; margin-top:-0.5rem; height: 1rem; line-height: 1rem; min-width: 1rem; text-align: center;"
                  >{{ unreadCount }}</span>
                </router-link>
              </li>
              <li>
                <router-link
                  :to="{name: 'device'}"
                  class="block no-underline text-90 hover:bg-30 p-3"
                >{{$t("Device")}}</router-link>
              </li>
              <li>
                <a
                  class="block no-underline text-90 hover:bg-30 p-3"
                  @click="logout"
                >{{ $t('Logout') }}</a>
              </li>
            </ul>
          </dropdown-menu>
        </dropdown>
      </li>
    </ul>
  </div>
</template>


<script>
import { mapGetters, mapActions } from 'vuex';
import OnFreePlan from '@mobile/mixins/OnFreePlan';
import StarredItem from '@mobile/components/StarredItem';
import BellIcon from '@/components/Icons/BellIcon.vue';
import { ISSUE_PERMISSIONS } from '@/constants';

export default {
    components: {
        StarredItem,
        BellIcon,
    },

    mixins: [
        OnFreePlan,
    ],

    computed: {
        ...mapGetters({
            hasPermission: 'authentication/hasPermission',
            hasAnyPermissions: 'authentication/hasAnyPermissions',
        }),
        shouldDisplayChecks() {
            return this.hasPermission('conduct-open-inspections');
        },
        shouldDisplayIssues() {
            return this.hasAnyPermissions([
                ISSUE_PERMISSIONS.MANAGE_OWN_PERMISSION_NAME,
                ISSUE_PERMISSIONS.MANAGE_ALL_PERMISSION_NAME,
                ISSUE_PERMISSIONS.MANAGE_SITE_PERMISSION_NAME,
                ISSUE_PERMISSIONS.MANAGE_ASSIGNED_SOLVED_PERMISSION_NAME,
            ]);
        },
        shouldDisplayRaiseIssues() {
            return !this.shouldDisplayIssues && this.hasAnyPermissions([
                ISSUE_PERMISSIONS.CREATE_PERMISSION_NAME,
                ISSUE_PERMISSIONS.CREATE_ISSUE_WITH_ASSIGNEE,
            ]);
        },
        unreadCount() {
            return 0; // disable unread count temporarly
            // return this.$store.getters['notifications/unread_count'];
        },
    },

    methods: {
        ...mapActions({
            logout: 'authentication/logout',
        }),
    },
};
</script>
